import React, { useState } from "react";
import { UiButton } from "../../components/form/UiButton";
import { UiFormFooter } from "../../components/common/UiFormFooter";
import { UiCheckboxInput, UiInput, UiInputLink } from "../../components/form/UiInput";
import { UiModal } from "../../components/common/UiModal";
import { UiCol, UiRowContainer, UiSingleRow } from "../../components/grid-container/GridContainer";
import GoogleIcon from "../../../../styles/img/googlIcon.png";
import { EyeIcon } from "../../../../styles/img/svg/EyeIcon";
import { FacebookIcon } from "../../../../styles/img/svg/FacebookIcon";

export const LoginPage = () => {

    return (
        <>

           
                {/* <div className="sb-signup-page__button-set">
                    <UiButton
                        className="sb-main-primary-button"
                        title="Sign in with Google"
                        imageIcon={GoogleIcon}
                    />

                    <UiButton
                        className="sb-main-dark-button"
                        svgIcon={<FacebookIcon />}
                    />
                </div> */}

                {/* <div className="sb-signup-page__continue-with">
                    <p>or continue with </p>
                </div> */}
                
                <UiSingleRow>

                    <UiCol lg="12">
                        <UiInput
                            label="Email address"
                            placeholder="Enter your email"
                            type="email"
                        />
                    </UiCol>

                    <UiCol lg="12">
                        <UiInput
                            label="Password"
                            placeholder="Password"
                            type="password"
                            inputHideIcon={<EyeIcon />}
                        />
                    </UiCol>


                    <UiCol lg="12">
                        <UiInputLink
                            text="Forgot your password?"
                            link="/"
                            align="right"
                        />
                    </UiCol>

                    <UiCol lg="12">
                        <UiButton
                            className="sb-main-primary-button sb-submit-button"
                            title="Sign in"
                        />
                    </UiCol>

                    <UiCol lg="12">
                        <UiFormFooter
                            text="Haven't got an account?"
                            link="/sign-up"
                            linkText="Sign up now"
                        />
                    </UiCol>

                </UiSingleRow>
          


        </>
    )
}